<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.cdsim) }}</div>
            </div>
            <div class="form-item">
                <label class="label-caption" for="nmsim">Nome do SIM</label>
                <input type="text" v-model="objEdicao.nmsim" id="nmsim" required maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption" for="cnpj">CNPJ</label>
                <input type="text" class="input-center" v-model="objEdicao.cnpj" id="cnpj" maxlength="18" v-cnpj />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="endereco">Endereço</label>
                <input type="text" v-model="objEdicao.endereco" id="endereco" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="nmendereco">Número</label>
                <input type="text" class="input-right" v-model="edNmEndereco" id="nmendereco" v-number maxlength="7" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="complemento">Complemento</label>
                <input type="text" v-model="objEdicao.complemento" id="complemento" maxlength="80" v-uppercase />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="bairro">Bairro</label>
                <input type="text" v-model="objEdicao.bairro" id="bairro" maxlength="60" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="cep">CEP</label>
                <input type="text" v-model="objEdicao.cep" id="cep" v-cep maxlength="10" />
            </div>
            <MunicipioSelect class="form-item" v-model:idSelecionado="objEdicao.idmunicipio" required />
        </div>

        <div class="row row-space">
            <div class="form-item-telefone">
                <label class="label-caption" for="fone">Telefone</label>
                <input type="text" v-model="objEdicao.fone" id="fone" v-phone maxlength="15" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="email">Email</label>
                <input type="email" v-model="objEdicao.email" id="email" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="rptitulo">Título Relatórios</label>
                <input type="text" v-model="objEdicao.rptitulo" id="rptitulo" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="rpsubtitulo">Subtítulo Relatórios</label>
                <input type="text" v-model="objEdicao.rpsubtitulo" id="rpsubtitulo" />
            </div>

            <div class="form-item-coordenadas">
                <CoordenadasSelect v-model:modelValueLatitude="edLatitude" v-model:modelValueLongitude="edLongitude" />
            </div>
        </div>

        <div class="row-end row-space">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { criarSim } from '@/models/sim';
import { onMounted, ref } from 'vue';
import { formatInteger, integerFromString } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import CoordenadasSelect from '@/components/CoordenadasSelect.vue';
import MunicipioSelect from '@/components/selects/MunicipioSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const edLatitude = ref(0);
const edLongitude = ref(0);
const edNmEndereco = ref(null);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarSim());

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('sim', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
        objEdicao.value.idusuario       = globalStore.idusuario;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';     
        edNmEndereco.value              = formatInteger(objEdicao.value.nmendereco);  
        edLatitude.value                = objEdicao.value.latitude;
        edLongitude.value               = objEdicao.value.longitude;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    if (!objEdicao.value.nmsim || objEdicao.value.nmsim.trim() === '') {msgAlerta.value='Informe o nome do SIM'; return;}
    try {
        isLoading.value             = true;
        msgAlerta.value             = null;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.nmendereco  = integerFromString(edNmEndereco.value);  
        objEdicao.value.latitude    = !edLatitude.value ? 0 : parseFloat(edLatitude.value.toString().replace(',', '.')) || 0;
        objEdicao.value.longitude   = !edLongitude.value ? 0 : parseFloat(edLongitude.value.toString().replace(',', '.')) || 0;
        const response              = await genericPut('/cad/sim', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>